import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { MailOutline } from "@material-ui/icons";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput";
import Button from "components/CustomButtons/Button.js";
import { bookingApi } from "functions/apis";
import { validateImageUpload } from "functions/Helper";

const useStyles = makeStyles(styles);

export default function UploadAnnouncementBanner(props) {
  const classes = useStyles();
  const { id } = useParams();
  const signal = useRef(new AbortController());

  const [announcement, setAnnouncement] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    bookingApi
      .get("Announcements/" + id, { signal: signal.current.signal })
      .then(setAnnouncement)
      .catch(error => console.log(error));
    return () => signal.current.abort();
  }, [id]);

  const handleUpload = e => {
    const file = e.target.files[0];
    const error = validateImageUpload(file);
    setUploadError(error);
    setUploadedFile(error ? null : file);
  };

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    const data = new FormData();
    data.append("file", uploadedFile);

    bookingApi
      .post("Announcements/Banner/" + id, data, {
        signal: signal.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        if (signal.current.signal.aborted) return;
        console.log(error);
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/Announcement/List"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>UPLOAD BANNER IMAGE</h4>
          </CardHeader>
          <CardBody>
            <p>
              <i>
                {announcement?.banner
                  ? "*This announcement already has a banner. Uploading again will replace it."
                  : "*Please upload your banner image."}{" "}
                Recommended size 1060 x 614 px (530:307). JPG, max 1 MB.
              </i>
            </p>
            <form onSubmit={handleSubmit}>
              <GridContainer>
                <GridItem xs={12} sm={6}>
                  <CustomInput
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      onChange: handleUpload,
                      type: "file",
                      inputProps: { accept: ".jpg,.jpeg" }
                    }}
                  />
                  {uploadError && (
                    <p style={{ color: "red" }}>
                      <i>{uploadError}</i>
                    </p>
                  )}
                </GridItem>
              </GridContainer>
              <Button onClick={() => props.history.goBack()} value="back">
                BACK
              </Button>
              <Button
                disabled={disabled || !uploadedFile}
                color="rose"
                type="submit"
                value="Submit"
              >
                Submit
              </Button>
            </form>
            {announcement && (
              <div>
                <CustomInput
                  labelText="Title"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: announcement.title ?? "",
                    disabled: true
                  }}
                />
                <CustomInput
                  labelText="Current Banner"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: announcement.banner ?? "No banner",
                    disabled: true
                  }}
                />
                {announcement.banner && (
                  <img
                    src={announcement.banner}
                    alt="Current banner"
                    style={{ maxWidth: 360, maxHeight: 180, borderRadius: 6 }}
                  />
                )}
              </div>
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

UploadAnnouncementBanner.propTypes = {
  history: PropTypes.object
};
